import React, { useEffect, useState } from "react";
import { InstitutionApiCalls } from "../../apis/InstitutionApiCalls";
import { UserApiCalls } from "../../apis/UserApiCalls";
import YuJaButton from "../../components/standardization/YuJaButton";
import { useLocalStorageNew } from "../../hooks/useLocalStorageNew";
import {
    MENU_LIST,
    DEFAULT_ATTENDANCE_MANUAL_END,
    DEFAULT_ATTENDANCE_TIME_LIMIT,
    DEFAULT_CLASS_RESULT_TIME_LIMIT,
    DEFAULT_ENTRIES_PER_PARTICIPANT,
    DEFAULT_GET_READY_ALL_TIME_LIMIT,
    DEFAULT_GET_READY_TIME_LIMIT,
    DEFAULT_LOGIN_METHODS,
    DEFAULT_POINTS,
    DEFAULT_POLL_BREAK_TIME_LIMIT,
    DEFAULT_POLL_LMS_SYNC,
    DEFAULT_POLL_MAX_ATTEMPTS,
    DEFAULT_POLL_RECORD_ATTEMPTS,
    DEFAULT_POLL_REQUIRED_NAME,
    DEFAULT_POLL_SHOW_CORRECT_ANS,
    DEFAULT_POLL_TIME_LIMIT,
    DEFAULT_PPT_AUTO_SHARE,
    DEFAULT_TIME_LIMIT,
    DEFAULT_TOAST_MESSAGE_DURATION,
    PLATFORM_SETTINGS,
    PLATFORM_SETTING_SAVE_ERROR_MSG,
    ROLES,
    USER_SETTINGS,
    DEFAULT_ATTENDANCE_SAVED_LOCATIONS,
    SAVE_ALL_CHANGES_TEXT, SETTING_TAB, MINIMUM_POLL_TIME_LIMIT,
} from "../../utils/constants";
import {notifyError, notifySuccess} from "../../utils/helpers";
import {
    ATTENDANCE_TIME_LIMIT_MIN_ERROR,
    POLL_TIME_LIMIT_MIN_ERROR,
    SAVE_SETTINGS_SUCCESS
} from "../../utils/toast-message-constants";
import BrandingTab from "./BrandingTab";
import PlatformSettingsTab from "./PlatformSettingTab";
import UserSettingsTab from "./UserSettingTab";
import classes from "./Settings.module.css";
import { useLocation } from "react-router-dom";
import useHostResource from "../../hooks/useHostResource";

export default function PlatformSetting({ setPageIdentifier }) {
    const [, getSession] = useLocalStorageNew("session", {});
    const [platformSettings, setPlatformSettings] = useState({});
    const [displayKey, setDisplayKey] = useState(SETTING_TAB.PLATFORM.key);
    const [loading, setLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const {uploadImg, uploadLogoImg, } = InstitutionApiCalls();
    const {updateImageURL, updateLogoImageURL, updatePlatformSetting} = useHostResource(window.location.hostname);
    const session = getSession();
    const [imgUrl, setImgUrl] = useState("");
    const [logoImgUrl, setLogoImgUrl] = useState("");
    const {role = ROLES.ANONYMOUS.value } = session;
    const location = useLocation();
    const [userSettings,  setUserSettings] = useState(() => {
        const {settings={}} = session;
        if (!settings.hasOwnProperty(USER_SETTINGS.TOAST_MESSAGE_DURATION)) {
            settings[USER_SETTINGS.TOAST_MESSAGE_DURATION] = DEFAULT_TOAST_MESSAGE_DURATION.toString();
        }
        if (!settings.hasOwnProperty(USER_SETTINGS.QUESTION_DURATION)) {
            settings[USER_SETTINGS.QUESTION_DURATION] = DEFAULT_TIME_LIMIT;
        }
        if (!settings.hasOwnProperty(USER_SETTINGS.QUESTION_POINTS)) {
            settings[USER_SETTINGS.QUESTION_POINTS] = DEFAULT_POINTS;
        }
        if (!settings.hasOwnProperty(USER_SETTINGS.QUESTION_COUNTDOWN)) {
            settings[USER_SETTINGS.QUESTION_COUNTDOWN] = DEFAULT_GET_READY_TIME_LIMIT;
        }
        if (!settings.hasOwnProperty(USER_SETTINGS.QUESTION_ENTRIES)) {
            settings[USER_SETTINGS.QUESTION_ENTRIES] = DEFAULT_ENTRIES_PER_PARTICIPANT;
        }
        if (!settings.hasOwnProperty(USER_SETTINGS.QUESTION_CLASS_RESULT_DURATION)) {
            settings[USER_SETTINGS.QUESTION_CLASS_RESULT_DURATION] = DEFAULT_CLASS_RESULT_TIME_LIMIT;
        }
        if (!settings.hasOwnProperty(USER_SETTINGS.POLL_DURATION)) {
            settings[USER_SETTINGS.POLL_DURATION] = DEFAULT_POLL_TIME_LIMIT;
        }
        if (!settings.hasOwnProperty(USER_SETTINGS.POLL_REQUIRED_NAME)) {
            settings[USER_SETTINGS.POLL_REQUIRED_NAME] = DEFAULT_POLL_REQUIRED_NAME;
        }
        if (!settings.hasOwnProperty(USER_SETTINGS.POLL_SHOW_CORRECT_ANS)) {
            settings[USER_SETTINGS.POLL_SHOW_CORRECT_ANS] = DEFAULT_POLL_SHOW_CORRECT_ANS;
        }
        if (!settings.hasOwnProperty(USER_SETTINGS.POLL_LMS_SYNC)) {
            settings[USER_SETTINGS.POLL_LMS_SYNC] = DEFAULT_POLL_LMS_SYNC;
        }
        if (!settings.hasOwnProperty(USER_SETTINGS.POLL_COUNTDOWN)) {
            settings[USER_SETTINGS.POLL_COUNTDOWN] = DEFAULT_GET_READY_ALL_TIME_LIMIT;
        }
        if (!settings.hasOwnProperty(USER_SETTINGS.POLL_RECORD_ATTEMPTS)) {
            settings[USER_SETTINGS.POLL_RECORD_ATTEMPTS] = DEFAULT_POLL_RECORD_ATTEMPTS;
        }
        if (!settings.hasOwnProperty(USER_SETTINGS.POLL_MAX_ATTEMPTS)) {
            settings[USER_SETTINGS.POLL_MAX_ATTEMPTS] = DEFAULT_POLL_MAX_ATTEMPTS;
        }
        if (!settings.hasOwnProperty(USER_SETTINGS.SURVEY_RECORD_ATTEMPTS)) {
            settings[USER_SETTINGS.SURVEY_RECORD_ATTEMPTS] = DEFAULT_POLL_RECORD_ATTEMPTS;
        }
        if (!settings.hasOwnProperty(USER_SETTINGS.SURVEY_MAX_ATTEMPTS)) {
            settings[USER_SETTINGS.SURVEY_MAX_ATTEMPTS] = DEFAULT_POLL_MAX_ATTEMPTS;
        }
        if (!settings.hasOwnProperty(USER_SETTINGS.POLL_BREAK_DURATION)) {
            settings[USER_SETTINGS.POLL_BREAK_DURATION] = DEFAULT_POLL_BREAK_TIME_LIMIT;
        }
        if (!settings.hasOwnProperty(USER_SETTINGS.ATTENDANCE_MANUAL_END)) {
            settings[USER_SETTINGS.ATTENDANCE_MANUAL_END] = DEFAULT_ATTENDANCE_MANUAL_END;
        }
        if (!settings.hasOwnProperty(USER_SETTINGS.ATTENDANCE_DURATION)) {
            settings[USER_SETTINGS.ATTENDANCE_DURATION] = DEFAULT_ATTENDANCE_TIME_LIMIT;
        }
        if (!settings.hasOwnProperty(USER_SETTINGS.PPT_AUTO_SHARE)) {
            settings[USER_SETTINGS.PPT_AUTO_SHARE] = DEFAULT_PPT_AUTO_SHARE;
        }
        if (!settings.hasOwnProperty(USER_SETTINGS.ATTENDANCE_PPT_AUTO_SHARE)) {
            settings[USER_SETTINGS.ATTENDANCE_PPT_AUTO_SHARE] = DEFAULT_PPT_AUTO_SHARE;
        }
        if (!settings.hasOwnProperty(USER_SETTINGS.ATTENDANCE_SAVED_LOCATIONS)) {
            settings[USER_SETTINGS.ATTENDANCE_SAVED_LOCATIONS] = DEFAULT_ATTENDANCE_SAVED_LOCATIONS;
        }

        return settings;
    });
    const {getSetting, updateSetting} = InstitutionApiCalls();
    const {saveSettings} = UserApiCalls();


    useEffect(() => {
        getSetting().then((result) => {
            if (result !== null) {
                setPlatformSettings(result);

            }
        }).finally(() => {
            setLoading(false);
        });

        if(document.getElementById("platformLastElem") != null) {
            document.getElementById("platformLastElem").addEventListener('keydown', function (e) {
                if (e.key === 'Tab' && !e.shiftKey && document.getElementById("settingsSaveBtn")) {
                  e.preventDefault();
                  document.getElementById('settingsSaveBtn').focus();
                }
            });
        }

        if(document.getElementById("brandingLastElem") != null) {
            document.getElementById("brandingLastElem").addEventListener('keydown', function (e) {
                if (e.key === 'Tab' && !e.shiftKey && document.getElementById("settingsSaveBtn")) {
                  e.preventDefault();
                  document.getElementById('settingsSaveBtn').focus();
                }
            });
        }

        if(document.getElementById("userLastElem") != null) {
            document.getElementById("userLastElem").addEventListener('keydown', function (e) {
                if (e.key === 'Tab' && !e.shiftKey && document.getElementById("settingsSaveBtn")) {
                  e.preventDefault();
                  document.getElementById('settingsSaveBtn').focus();
                }
            });
        }
    }, []);

    useEffect(() => {
        if (location && location.state) {
          if (location.state.User ) {
            setDisplayKey(SETTING_TAB.USER.key);
          } 
        }
      }, []);

    const handleSavePlatformSettings = async () => {
        if (platformSettings[PLATFORM_SETTINGS.YUJA_LOGIN] === "true" && platformSettings[PLATFORM_SETTINGS.DEFAULT] === DEFAULT_LOGIN_METHODS.YUJA_LOGIN) {
            notifyError(PLATFORM_SETTING_SAVE_ERROR_MSG)
            return;
        }
        await updateSetting(platformSettings);
        updatePlatformSetting(platformSettings);
    };

    const handleSaveUserSettings = async () => {
        await saveSettings(userSettings);
    };


    const handleSaveBGImage = async () => {
        const bgImageData = document.querySelector('#bg-file-input').files[0];
        if (!bgImageData || !bgImageData.name) {
            return;
        }

        await uploadImg(bgImageData, (url) => {
            setImgUrl(url);
            updateImageURL(url);
        });
    };


    const handleSaveLogoImage = async () => {
        const logoImageData = document.querySelector('#logo-file-input').files[0];
        if (!logoImageData || !logoImageData.name) {
            return;
        }

        await uploadLogoImg(logoImageData, (url) => {
            setLogoImgUrl(url);
            updateLogoImageURL(url);
        });
    };

    const handleSave = () => {
        if (userSettings && userSettings[USER_SETTINGS.POLL_DURATION] < 60) {
            notifyError(POLL_TIME_LIMIT_MIN_ERROR);
            return; 
        }
        if (userSettings
            && !userSettings[USER_SETTINGS.ATTENDANCE_MANUAL_END]
            && userSettings[USER_SETTINGS.ATTENDANCE_DURATION] < MINIMUM_POLL_TIME_LIMIT
        ) {
            notifyError(ATTENDANCE_TIME_LIMIT_MIN_ERROR);
            return; 
        }

        setIsSaving(true);

        const promiseList = [];
        if (role === ROLES.ADMINISTRATOR.value || role === ROLES.IT_MANAGER.value) {
            promiseList.push(handleSavePlatformSettings());
            promiseList.push(handleSaveBGImage());
            promiseList.push(handleSaveLogoImage());
        }

        promiseList.push(handleSaveUserSettings());

        Promise.all(promiseList).then(() => {
            notifySuccess(SAVE_SETTINGS_SUCCESS);
        }).finally(() => {
            setIsSaving(false);
        });
    };

    const handleSelect = (key) => {
        setDisplayKey(key);
      };

    useEffect(() => {
        setPageIdentifier(MENU_LIST.SETTINGS.name);
    }, []);




    return (
        <div className={classes.container}>
            {role === ROLES.CREATOR.value &&
                <>
                    <div style={{display: "flex", alignItems: "center"}}>
                        <span style={{flex: 1}}/>
                        <YuJaButton
                            index={0}
                            id="settingsSaveBtn"
                            onClick={handleSave}
                            style={{
                                width: 160, height: 35,
                                display: "flex", alignItems: "center", justifyContent: "center",
                                fontSize: 15, whiteSpace: "no-wrap"
                            }}
                            disabled={loading || isSaving}
                        >
                            <span className={isSaving ? classes.savingText : ""}>
                                {SAVE_ALL_CHANGES_TEXT}
                            </span>
                        </YuJaButton>
                    </div>
                    <div className={`${classes.tabPane} ${classes.active}`}>
                        <UserSettingsTab userSettings={userSettings} setUserSettings={setUserSettings}/>
                    </div>

                </>

            }
            {(role === ROLES.ADMINISTRATOR.value || role === ROLES.IT_MANAGER.value) &&
                <>

                    <div className={classes.tabsRow}>
                        {Object.values(SETTING_TAB).map((tab, index) =>
                            <span
                                tabIndex={0}
                                key={index}
                                onClick={() => handleSelect(tab.key)}
                                className={`${classes.tabItem} ${displayKey === tab.key ? classes.active : ""}`}
                            >{tab.label}</span>
                        )}
                    </div>

                    <div style={{display: "flex"}}>
                        <span style={{flex: 1}}/>
                        <YuJaButton
                            index={0}
                            id="settingsSaveBtn"
                            onClick={handleSave}
                            style={{
                                width: 160, height: 35,
                                display: "flex", alignItems: "center", justifyContent: "center",
                                fontSize: 15, whiteSpace: "no-wrap"
                            }}
                            disabled={loading || isSaving}
                        >
                            <span className={isSaving ? classes.savingText : ""}>
                                {SAVE_ALL_CHANGES_TEXT}
                            </span>
                        </YuJaButton>
                    </div>


                    <div
                        className={`${classes.tabPane} ${displayKey === SETTING_TAB.PLATFORM.key ? classes.active : ""}`}>
                        <PlatformSettingsTab
                            platformSettings={platformSettings}
                            setPlatformSettings={setPlatformSettings}
                            loading={loading}
                            setLoading={setLoading}
                        />
                    </div>

                    <div className={`${classes.tabPane} ${displayKey === SETTING_TAB.USER.key ? classes.active : ""}`}>
                        <UserSettingsTab userSettings={userSettings} setUserSettings={setUserSettings}/>
                    </div>

                    <div
                        className={`${classes.tabPane} ${displayKey === SETTING_TAB.BRANDING.key ? classes.active : ""}`}>
                        <BrandingTab bgImgUrl={imgUrl} setBgImgUrl={setImgUrl} logoImgUrl={logoImgUrl}
                                     setLogoImgUrl={setLogoImgUrl}/>
                    </div>
                </>
            }
        </div>
    )

}